﻿﻿﻿<contractbundlelist [list]="list" (onReload)="onReload()"></contractbundlelist>